import { Button, ButtonProps } from "@jugl-web/ui-components";
import React from "react";

export const DisabledChatInput: React.FC<{
  text: string;
  buttonProps?: Omit<ButtonProps, "ref"> & {
    text: string;
  };
}> = ({ text, buttonProps }) => (
  <div className="flex flex-col items-center justify-center gap-4 px-8 py-6 text-center">
    <span className="text-dark font-secondary max-w-[700px] text-sm leading-[21px]">
      {text}
    </span>
    {buttonProps && (
      <Button {...buttonProps} className={buttonProps.className}>
        {buttonProps.text}
      </Button>
    )}
  </div>
);
